import { defineComponent, useSlots, computed, ref, onMounted, onUnmounted } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "InputH5",
  props: {
    theme: { default: "white" },
    modelValue: { default: "" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: false },
    type: { default: "text" },
    readonly: { type: Boolean },
    enterkeyhint: { default: "" },
    search: null,
    select: null,
    maxlength: { default: "80" },
    border: { type: Boolean, default: true },
    align: { default: "left" }
  },
  emits: [
    "update:modelValue",
    "input",
    "focus",
    "blur",
    "done"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const themeClass = computed(
      () => props.theme ? `tui-theme-${props.theme}` : ""
    );
    const tuiInputRef = ref(null);
    const inputRef = ref(null);
    const show = ref(false);
    const blur = (event) => {
      const { value } = event.target;
      show.value = false;
      const trimmedValue = value.trimStart().trimEnd();
      if (value !== trimmedValue) {
        event.target.value = trimmedValue;
      }
      emit("blur", tuiInputRef.value);
    };
    const done = () => {
      emit("done", tuiInputRef.value);
    };
    const focus = () => {
      show.value = true;
      emit("focus", tuiInputRef.value);
    };
    const handleSuffixIconClick = () => {
      var _a;
      (_a = inputRef.value) == null ? void 0 : _a.blur();
    };
    const closeOnOutsideClick = (event) => {
      var _a;
      if (!((_a = tuiInputRef.value) == null ? void 0 : _a.contains(event.target))) {
        show.value = false;
      }
    };
    function handleResultItemClick(item) {
      var _a;
      (_a = inputRef.value) == null ? void 0 : _a.blur();
      if (props.select) {
        props.select(item);
      }
    }
    onMounted(() => {
      window.addEventListener("click", closeOnOutsideClick);
    });
    onUnmounted(() => {
      window.removeEventListener("click", closeOnOutsideClick);
    });
    const searchResult = ref([]);
    function handleInput(event) {
      const { value } = event.target;
      const trimmedValue = value.trimStart();
      if (value !== trimmedValue) {
        event.target.value = trimmedValue;
      }
      emit("update:modelValue", trimmedValue);
      emit("input", trimmedValue);
      if (props.search) {
        searchResult.value = props.search(event.target.value);
      }
    }
    const showResults = computed(
      () => {
        var _a;
        return searchResult.value && ((_a = searchResult.value) == null ? void 0 : _a.length) !== 0 && show.value;
      }
    );
    const hasSuffixIcon = computed(() => !!slots.suffixIcon);
    const inputStyle = computed(() => {
      let paddingRight = "16px";
      if (hasSuffixIcon.value) {
        paddingRight = "40px";
      } else if (props.align === "right") {
        paddingRight = "0";
      }
      return {
        paddingRight,
        textAlign: props.align
      };
    });
    return { __sfc: true, slots, props, themeClass, emit, tuiInputRef, inputRef, show, blur, done, focus, handleSuffixIconClick, closeOnOutsideClick, handleResultItemClick, searchResult, handleInput, showResults, hasSuffixIcon, inputStyle };
  }
});
export {
  _sfc_main as default
};
